<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig" @onPath="updateCurrentUser"/>
    <editor-links :config="{id: gridConfig.id, api: 'AppUsers/Get/'}"/>
  </div>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'UsersManagementIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor-links': () => import(/* webpackChunkName: 'UsersManagement' */ './Editor')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  methods: {
    updateCurrentUser (e) {
      if (e.data.id === this.$store.getters.get('currentUser').id) {
        this.$store.dispatch('getCurrentAppUser')
      }
    }
  }
}
</script>
